import { BookOpenText, ArrowRight } from "lucide-react";
import { ENAGA_PHOTOS } from "@/lib/localMedia";
import { useDonation } from "@/context/DonationContext";

export default function NossaHistoria() {
  const { openModal } = useDonation();
  return (
    <section
      id="historia"
      data-testid="historia-section"
      className="section-pad bg-white"
    >
      <div className="container-ga">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <div className="pill border-ga-amber/30 text-ga-amber_deep bg-ga-amber/10 mb-6" data-testid="historia-pill">
              <BookOpenText className="w-3.5 h-3.5" /> Nossa História
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-ga-ink">
              De uma vontade de <span className="gradient-text-ga">transformar</span> para um instituto inteiro.
            </h2>
            <p className="mt-6 text-ga-ink/70 text-lg leading-relaxed">
              O Instituto GA+ surgiu a partir do desejo de transformar a
              realidade de jovens através do esporte, ampliando suas ações
              para saúde, inclusão social e apoio às famílias.
            </p>

            <ol className="mt-10 space-y-5 relative pl-6 before:absolute before:left-1 before:top-2 before:bottom-2 before:w-px before:bg-ga-ink/15">
              {[
                { year: "Início", text: "Tudo começou com o esporte: futebol, basquete e artes marciais como ferramentas de formação para crianças e jovens." },
                { year: "Expansão", text: "Chegada das terapias e do cuidado em saúde integral: nasce a ENAGA, clínica multiprofissional do Instituto." },
                { year: "Hoje", text: "Uma estrutura completa com quadras, piscinas e centro terapêutico, atendendo dezenas de jovens e famílias todos os dias." },
              ].map((m, i) => (
                <li
                  key={m.year}
                  data-testid={`historia-marco-${i}`}
                  className="relative pl-4"
                >
                  <span className="absolute -left-[22px] top-1.5 w-3 h-3 rounded-full bg-ga-emerald ring-4 ring-ga-emerald/20" />
                  <div className="text-xs font-bold uppercase tracking-[0.2em] text-ga-emerald_deep">
                    {m.year}
                  </div>
                  <p className="mt-1 text-ga-ink/75">{m.text}</p>
                </li>
              ))}
            </ol>

            <button
              type="button"
              onClick={() => openModal("historia")}
              data-testid="historia-cta"
              className="mt-8 btn-primary"
            >
              Caminhar com a gente
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>

          <div className="lg:col-span-6">
            <div className="relative rounded-[2rem] overflow-hidden aspect-[4/5] shadow-xl">
              <img
                src={ENAGA_PHOTOS.desenvolvimento}
                alt="Educação e desenvolvimento no Instituto"
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ga-ink/80 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-ga-amber">Raíz do Instituto</div>
                <div className="font-display font-bold text-2xl mt-1 leading-tight">
                  A educação e o cuidado caminham juntos desde o primeiro dia.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
